import {landings} from '../Pages/landingPages';
export const MEASUREMENT_ID = 'G-VWBWPJ2Q3E';
export const CONSENT_KEY = 'technogenious-analytics-consent-v1';
const titles: Record<string,string> = {'/':'Home','/products':'Products','/gaming-machines':'Gaming machines','/build-your-machine':'Build your machine','/about':'About us','/services':'Services','/contact':'Contact','/FAQs':'FAQs','/privacy-policy':'Privacy policy','/warranties':'Warranties','/termscondition':'Terms and conditions','/disclaimer':'Disclaimer','/leasing':'Leasing','/request-quote':'Request a quote','/cart':'Cart',
  // Search landing pages, by their headline.
  ...Object.fromEntries(landings.map(l=>[l.path,l.title]))};
export function publicPage(path: string) {
  if(titles[path]) return {path,title:titles[path]};
  const match=path.match(/^\/(product|shop|game-product-detail)\/[a-f\d]{24}$/i);
  return match ? {path,title:match[1]==='shop'?'Category':'Product'} : null;
}
export function productionHost(host:string) {return ['technogeniousja.com','www.technogeniousja.com'].includes(host);}
export function readConsent() {try {return localStorage.getItem(CONSENT_KEY);} catch {return null;}}
let initialized=false;
let lastPage='';
// Use only a fixed public-route allowlist. Never send query strings, form values or account IDs.
export function trackPage(path:string, accepted:boolean, host=window.location.hostname) {
  const w=window as any;
  const page=publicPage(path);
  const enabled=accepted && productionHost(host) && !!page;
  w[`ga-disable-${MEASUREMENT_ID}`]=!enabled;
  if(!enabled) {lastPage='';return;}
  w.dataLayer=w.dataLayer||[];
  w.gtag=w.gtag||function(){w.dataLayer.push(arguments);};
  const location=`https://${host}${page!.path}`;
  if(!initialized) {
    w.gtag('consent','default',{analytics_storage:'granted',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
    w.gtag('js',new Date());
    w.gtag('config',MEASUREMENT_ID,{send_page_view:false,allow_google_signals:false,allow_ad_personalization_signals:false,page_location:location,page_referrer:'',page_title:page!.title});
    const script=document.createElement('script');script.async=true;script.id='techno-ga4';script.src=`https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;document.head.appendChild(script);
    initialized=true;
  }
  if(lastPage===path)return;
  w.gtag('set',{page_location:location,page_referrer:'',page_title:page!.title});
  w.gtag('event','page_view',{send_to:MEASUREMENT_ID,page_location:location,page_referrer:'',page_title:page!.title});
  lastPage=path;
}

type Item = { id?: string; _id?: string; name?: string; price?: number; quantity?: number; optionName?: string };
/** GA4 ecommerce item. Product id, name, option, price and quantity only. */
export function gaItem(i: Item) {
  return { item_id: String(i.id || i._id || ''), item_name: String(i.name || '').slice(0, 100), ...(i.optionName ? { item_variant: String(i.optionName).slice(0, 100) } : {}), price: Number(i.price) || 0, quantity: Number(i.quantity) || 1 };
}
/**
 * Sends one conversion event (WhatsApp or phone tap, add to cart, checkout
 * started, enquiry sent). Same rules as page views: only after consent, only
 * on the live site and only from public pages, whose path is sent without the
 * query string. Never pass form contents or contact details.
 */
export function trackEvent(name: string, params: Record<string, unknown> = {}, path = window.location.pathname, host = window.location.hostname) {
  const page = publicPage(path);
  if (readConsent() !== 'accepted' || !productionHost(host) || !page || !initialized) return false;
  const w = window as any;
  w.gtag('event', name, { send_to: MEASUREMENT_ID, page_location: `https://${host}${page.path}`, ...params });
  return true;
}
